import { Dimensions } from "react-native";
import Color from "../../assets/color/Color";
import StyleSheet from "react-native-media-query";
import { theme } from "../../theme/theme";
// Define your styles
export const { ids, styles } = StyleSheet.create({
  containerFluid: {
    display: "flex",
    flex: 1,
    backgroundColor: 'rgba(0,0,0,.2)',
  },
  container: {
    justifyContent: "flex-start",
    alignItems: "center",
    flex: 1,
  },
  pdf: {
    width: "100%",
    height: "100%",
    backgroundColor: 'rgba(0,0,0,.2)',
  },
  navigation: {
    elevation: 999,
    width: "100%",
  },
});
